export const DEFAULT_TRUNCATE_LEN = 112
export const DEFAULT_TRUNCATE_LEN_COMMENT = 48
export const DEFAULT_TRUNCATE_LEN_SOURCES = 38

export const DEFAULT_EMPTY_SOURCES_TXT = 'Источник не выбран'
export const DEFAULT_EMPTY_AGE_TXT = 'Не указан' // Возраст не выбран
